import {openResourceModal} from '../../core/modalCommand';
import {reportActiveAgentModalLifecycle} from '../../core/modalLifecycle';
import {
	REPORTS_CREATE_MODAL_EVENT,
	REPORTS_DELETE_MODAL_EVENT,
	REPORTS_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open the Custom Report form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openReportsCreateModal(command, envelope) {
	return openResourceModal(
		REPORTS_CREATE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Edit Report form.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openReportsEditModal(command, envelope) {
	return openResourceModal(
		REPORTS_EDIT_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Open the Report delete confirmation.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openReportsDeleteModal(command, envelope) {
	return openResourceModal(
		REPORTS_DELETE_MODAL_EVENT,
		command,
		envelope,
	);
}

/**
 * Report a Reports modal outcome.
 * @param {'modal.cancelled'|'modal.saved'|'modal.failed'} eventType lifecycle event
 * @param {string|null} [errorCode] failure reason when the save did not complete
 * @return {Promise<object|null>} agent response
 */
export function reportReportsModalLifecycle(eventType, errorCode = null) {
	return reportActiveAgentModalLifecycle(eventType, errorCode);
}
